<script setup lang="ts">
defineProps<{
  radius?: 'r2' | '_br14'
  repeat?: number
  height?: '_h14' | '_h20' | '_h28' | '_h50' | '_h60' | '_h80'
  width?: '_w220' | '_w70ch' | '_w100p' | '_w120'
  mb?: '_mb04' | '_mb1'
  z?: 'z1' | 'z-1'
  inset?: boolean
  white?: boolean
}>()
</script>

<template>
  <span v-for="i in (repeat || 1)" :key="i" v-bind="$attrs" :class="[$style.i, height, width || '_w100p', mb, z, inset && '_absolute _inset', (radius || '_br9'), { white }]" />
</template>

<style module>
.i {
  composes: global(_block);
  composes: global(_hidden);

  --l: 95%;
  --bg1: hsl(240deg 1% var(--l));
  --bg2: hsl(240deg 1% calc(var(--l) - 5%));
  background-color: var(--bg1);
  background-image: linear-gradient(90deg, var(--bg1), var(--bg2), var(--bg1));
  animation: 1.5s ease-in-out 0s infinite normal none running admination;
  background-size: 200px 100%;
  background-repeat: no-repeat;

}
.i:global(.r2) {
  border-radius: 2px;
}
.i:global(.white) {
  --l: 99%
}

.i:global(.z1) {
  z-index: 1;
}
.i:global(.z-1) {
  z-index: -1;
}

@keyframes admination {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
}
</style>
